// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608311711/js/" + chunkId + "." + {"44":"4d49807a","225":"f31cd057","481":"1319b173","486":"dca80a7a","770":"57e98383"}[chunkId] + ".0.5547564504306253.chunk.js";
};